module.exports = __webpack_public_path__ + "static/media/showcase-1.bd202daa.jpg";